import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import {
  useMasksContext,
  useMasksFiltersContext,
} from "../../../providers";

import { Notification } from "../../../types/task";
import { Mask } from "../../../types/masks";
import { MasksFilters } from "../../../types/providers";

import useMasks from "../../../hooks/useMasks";


import MasksList from "./MasksList";
import MasksNotificationsList from "./MasksNotificationsList";
import MasksLoader from "./MasksLoader";

import styles from "./RightAside.module.css";

interface RightAsideProps {
  masks: Mask[];
  masksNotifications: Notification[];
}

const hasFiltersApplied = ({
  createdByUser,
  feedbackStatus,
  maskType,
  page: { from, to },
}: MasksFilters) => {
  return !!(createdByUser || feedbackStatus || maskType || from || to);
};

const RightAside = ({ masks, masksNotifications }: RightAsideProps) => {

  const { filtersApplied } =
    useMasksFiltersContext();

  const { isLoading } = useMasksContext();
  const { masksList, searchText, onChangeSearchText } = useMasks(
    masks,
    filtersApplied
  );

  return (
    <aside className={styles.rightAside}>
      <header className={styles.rightAsideHeader}>
        <div className={styles.searchContainer}>
          <Input
            onChange={onChangeSearchText}
            value={searchText}
            prefix={<SearchOutlined style={{ color: "#808085" }} />}
            placeholder="Cercar"
            style={{ borderColor: "#d0d0d1" }}
          />
        </div>
      </header>
      <section className={styles.masksContainer}>
        {isLoading ? (
          <MasksLoader />
        ) : (
          <>
            <MasksNotificationsList masksNotifications={masksNotifications} />
            <MasksList
              masksList={masksList}
              hasFiltersApplied={hasFiltersApplied(filtersApplied)}
            />
          </>
        )}
      </section>
    </aside>
  );
};
export default RightAside;
